import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { AccordionComponent, AccordionItemComponent, AccordionItemTitleDirective } from "@odx/angular/components/accordion";
import { ContentBoxComponent } from "@odx/angular/components/content-box";
import { MonitoringGroupedPartsTableComponent } from "./monitoring-grouped-parts-table.component";
import { MonitoringGroupedPartSection } from "./monitoring-grouped-parts.types";

@Component({
  selector: "app-monitoring-overview",
  imports: [
    AccordionComponent,
    AccordionItemComponent,
    AccordionItemTitleDirective,
    ContentBoxComponent,
    MonitoringGroupedPartsTableComponent,
    UiKitModule,
    CommonModule,
  ],
  templateUrl: "./monitoring-overview.component.html",
  styleUrl: "./monitoring-overview.component.scss",
  standalone: true,
})
export class MonitoringOverviewComponent {
  @Input() title?: string;
  @Input() sections: MonitoringGroupedPartSection[] = [];
  @Input() showCategory = true;
  @Input() showHeader = true;
  @Input() fullHeight = true;
}
